export default class QueriesController {
  #api;
  #paths;
  constructor(requestService, paths) {
    this.#api = requestService;
    this.#paths = paths;
  }

  async setModuleFocusOn({ childId, ModuleOrder }) {
    try {
      const path = this.#paths.initialSetup.addModuleFocusOn(childId);
      const { data } = await this.#api.Post(path, ModuleOrder);
      return data;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not save the on focus module.');
    }
  }
  async setInitialSetup({ childId, initialSetup }) {
    try {
      const path = this.#paths.initialSetup.addInitialSetup(childId);
      const { data } = await this.#api.Post(path, initialSetup);
      return data;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not save the initial setup.');
    }
  }
  async setDisableFirstTime({ firstTime }) {
    try {
      const path = this.#paths.initialSetup.disableFirstTime;
      const { data } = await this.#api.Post(path, firstTime);
      return data;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not save the initial setup.');
    }
  }
}
